import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControl, IconButton, InputBase, styled } from '@mui/material';

export const BootstrapInputStyled = styled(InputBase, {
  shouldForwardProp: (prop) =>
    prop !== 'touched' &&
    prop !== 'isSubmitting' &&
    prop !== 'isValidating' &&
    prop !== 'submitCount' &&
    prop !== 'initialValues' &&
    prop !== 'initialErrors' &&
    prop !== 'initialTouched' &&
    prop !== 'initialStatus' &&
    prop !== 'handleBlur' &&
    prop !== 'handleChange' &&
    prop !== 'handleReset' &&
    prop !== 'handleSubmit' &&
    prop !== 'resetForm' &&
    prop !== 'setErrors' &&
    prop !== 'setFormikState' &&
    prop !== 'setFieldTouched' &&
    prop !== 'setFieldValue' &&
    prop !== 'setFieldError' &&
    prop !== 'setStatus' &&
    prop !== 'setSubmitting' &&
    prop !== 'setTouched' &&
    prop !== 'setValues' &&
    prop !== 'submitForm' &&
    prop !== 'validateForm' &&
    prop !== 'validateField' &&
    prop !== 'isValid' &&
    prop !== 'dirty' &&
    prop !== 'unregisterField' &&
    prop !== 'registerField' &&
    prop !== 'getFieldProps' &&
    prop !== 'getFieldMeta' &&
    prop !== 'getFieldHelpers' &&
    prop !== 'validateOnBlur' &&
    prop !== 'validateOnChange' &&
    prop !== 'validateOnMount' &&
    prop !== 'initialValue' &&
    prop !== 'initialError',
})(({ error, disabled, theme }) => {
  const getBorder = () => {
    if (error) {
      return `solid 1px ${theme.palette.colors.down}`;
    }
    if (disabled) {
      return `solid 1px ${theme.palette.colors.secondaryDisabledText}`;
    }
    return `solid 1px ${theme.palette.colors.borderLine}`;
  };
  return {
    width: '100%',
    '& .MuiInputBase-input': {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.colors.secondaryBackground,
      border: getBorder(),
      fontSize: 12,
      width: '100%',
      color: theme.palette.colors.onSecondaryAndDetailBackground,
      fontWeight: 500,
      padding: '8px 0 7px 8px',

      '&:focus': {
        borderColor: theme.palette.colors.mainFocused,
      },
      '&.Mui-disabled': {
        WebkitTextFillColor: theme.palette.colors.secondaryDisabledText,
        backgroundColor: theme.palette.colors.secondaryDisabledBackground,
      },
      '&::placeholder': {
        fontWeight: 400,
        fontStyle: 'italic',
        color: theme.palette.colors.placeholderText,
        opacity: 1,
      },
    },

    '& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button':
      {
        WebkitAppearance: 'none',
        margin: 0,
      },
    '& input[type=number]': {
      MozAppearance: 'textfield', // Firefox
    },
  };
});

export const FormControlStyled = styled(FormControl, {
  shouldForwardProp: (prop) => prop !== 'isHidden',
})(({ isHidden }) => ({
  width: '100%',
  display: isHidden && 'none',
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  width: 15,
  height: 13,
  color: theme.palette.colors.mainFocused,
  background: 'none',
}));

export const IconButtonStyled = styled(IconButton)(() => ({
  position: 'absolute',
  right: 12,
}));
